import Image, { type ImageProps } from 'next/image';

const dimensions: Record<string, [number, number]> = {
  "/landing/assets/untangled/lighthouse.png": [517, 1400],
  "/landing/assets/untangled/lighthouse-base-bushes.png": [2172, 724],
  "/landing/assets/untangled/cloud-landscape.png": [2048, 504],
  "/landing/assets/figma/card-ring.svg": [
    1538,
    1538
  ],
  "/landing/assets/figma/chevron.svg": [
    23,
    13
  ],
  "/landing/assets/figma/enter-arrow.svg": [
    40,
    25
  ],
  "/landing/assets/figma/enter-ring.png": [
    246,
    246
  ],
  "/landing/assets/figma/final-clouds.png": [
    2048,
    1236
  ],
  "/landing/assets/figma/final-generative.png": [
    2048,
    504
  ],
  "/landing/assets/figma/final-object.png": [
    1024,
    389
  ],
  "/landing/assets/figma/initial-bg.png": [
    2048,
    1218
  ],
  "/landing/assets/figma/initial-clouds.png": [
    2048,
    1094
  ],
  "/landing/assets/figma/initial-generative.png": [
    2048,
    504
  ],
  "/landing/assets/figma/left-full.png": [
    2048,
    877
  ],
  "/landing/assets/figma/play.svg": [
    45,
    45
  ],
  "/landing/assets/figma/right-full.png": [
    2048,
    876
  ],
  "/landing/assets/untangled/coastal-reading.png": [
    1672,
    941
  ],
  "/landing/assets/untangled/untangling-threads.png": [
    1672,
    941
  ]
};

export function SceneImage({ src, alt, ...props }: Omit<ImageProps, 'src' | 'alt'> & { src: string; alt: string }) {
  const [width, height] = dimensions[src] ?? [1600, 1200];
  return <Image src={src} alt={alt} width={width} height={height} unoptimized loading="eager" {...props} />;
}
